export default "<div class=\"back-to-top\" (click)=\"backToTop()\"></div>\r\n<div class=\"go-to-bottom\" (click)=\"goToBottom()\"></div>"